"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HOME_KEY = exports.END_KEY = exports.PAGEDN_KEY = exports.PAGEUP_KEY = exports.SPACE_KEY = exports.DELETE_KEY = exports.ENTER_KEY = exports.TAB_KEY = exports.ESCAPE_KEY = exports.DOWN_KEY = exports.RIGHT_KEY = exports.UP_KEY = exports.LEFT_KEY = void 0;
var LEFT_KEY = 37;
exports.LEFT_KEY = LEFT_KEY;
var UP_KEY = 38;
exports.UP_KEY = UP_KEY;
var RIGHT_KEY = 39;
exports.RIGHT_KEY = RIGHT_KEY;
var DOWN_KEY = 40;
exports.DOWN_KEY = DOWN_KEY;
var ESCAPE_KEY = 27;
exports.ESCAPE_KEY = ESCAPE_KEY;
var TAB_KEY = 9;
exports.TAB_KEY = TAB_KEY;
var ENTER_KEY = 13;
exports.ENTER_KEY = ENTER_KEY;
var DELETE_KEY = 8;
exports.DELETE_KEY = DELETE_KEY;
var SPACE_KEY = 32;
exports.SPACE_KEY = SPACE_KEY;
var PAGEUP_KEY = 33;
exports.PAGEUP_KEY = PAGEUP_KEY;
var PAGEDN_KEY = 34;
exports.PAGEDN_KEY = PAGEDN_KEY;
var END_KEY = 35;
exports.END_KEY = END_KEY;
var HOME_KEY = 36;
exports.HOME_KEY = HOME_KEY;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/libs/constants.js
// module id = 1SPq
// module chunks = 0